import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=6a4ccf3e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=6a4ccf3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4ccf3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4ccf3e')) {
      api.createRecord('6a4ccf3e', component.options)
    } else {
      api.reload('6a4ccf3e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=6a4ccf3e&scoped=true&", function () {
      api.rerender('6a4ccf3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4SWvEOW8Z3cw0/JS/comp/GuestBox.vue"
export default component.exports